import React, {Component} from "react";
import TopNav from "../common/nav/TopNav";
import Footer from "../common/Footer";
import PageBlock from "../common/PageBlock"
import SubscriptionService from "../service/SubscriptionService";
import LogService from "../service/LogService";
import CoreService from "../service/CoreService";
import SiteService from "../service/SiteService";
import './Logs.css';
import {defaultTenantId} from "../service/TenantService";

class Logs extends Component {
    logService = {};

    constructor() {
        super();
        this.state = {
            logEndpoint: '',
            panelTitle: '',
        };
        this.logService = new LogService();
    }

    componentDidMount() {
        const that = this;

        // TODO support non-default tenants
        const tenantId = defaultTenantId;

        const serviceDescription = SiteService.describeService();
        this.setState({
            panelTitle: serviceDescription.substr(0, 1).toUpperCase() + serviceDescription.substr(1) + ' logs'
        });

        SubscriptionService.doIfSubscriptionActive(function () {
            that.logService.fetchLogEndpoint(tenantId, {
                success: (logEndpoint) => {
                    that.setState({
                        logEndpoint: logEndpoint.url
                    });
                },
                error: (_) => {
                    CoreService.showPassiveError("Sorry, we can't fetch your logs right now.");
                }
            });
        });
    }

    render() {
        return (
            <div>
                <TopNav tab="logs"/>

                <PageBlock>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 m-b-md">
                                <h1 className="page-header">Logs</h1>

                                <div className="row">
                                    <div className="col-sm-8">
                                        <h4 className="text-muted">{`See events from your ${SiteService.describeService()}.`}</h4>
                                    </div>
                                    <div className="col-sm-4 text-right">
                                        <a href={`${this.state.logEndpoint}`} target="_blank"
                                           disabled={this.state.logEndpoint.length > 0 ? '' : 'disabled'}
                                           className="btn btn-default btn-sm" type="button"><i className="icon icon-forward"/> Open in new window
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <div className="panel panel-default logs-panel">
                                    <iframe className="w-full logs-frame" src={this.state.logEndpoint}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </PageBlock>

                <Footer/>
            </div>
        );
    }
}

export default Logs;



// WEBPACK FOOTER //
// ./src/modules/views/Logs.js